export const ModuleAuth = 'auth';
export const ModuleCommon = 'common';
export const ModuleCompany = 'company';
export const ModuleConfig = 'config';
export const ModuleContactAdditional = 'contactadditional';
export const ModuleDashboard = 'dashboard';
export const ModuleDictionary = 'dictionary';
export const ModuleLayout = 'layout';
export const ModuleLicenseInfo = 'licenseinfo';
export const ModuleAccessLog = 'accesslog';
export const ModuleMisaOrder = 'misaorder';
export const ModuleNotification = 'notification';
export const ModuleOptions = 'options';
export const ModuleServiceTVAN = 'servicetvan';
export const ModuleTaxRegis = 'taxregis';
export const ModuleTaxReturnRegisHistory = 'taxreturnregishistory';
export const ModuleTaxReturn = 'taxreturn';
export const ModuleTaxReturnSubmission = 'taxreturnsubmission';
export const ModuleTaxPaper = 'taxpaper';
export const ModuleTaxPayerInfo = 'taxpayerinfo';
export const ModuleUser = 'user';
export const ModuleStateBudget = 'statebudget';
export const ModuleProducts = 'products';
export const ModuleNotiSetting = 'modulesettingnoti';
export const ModuleMisaStore = 'misastore';
export const ModuleRemoteSigning = 'remotesigning';
export const ModuleAgreement = 'agreement';
export const ModuleAmisConvert = 'amisconvert';
export const ModuleMws = 'mws';

/**
 * Danh sách module cần reset lại dữ liệu khi chọn lại mã số thuế.
 * KHÔNG chứa ModuleAuth — đổi MST phải giữ nguyên session (token, expiredDate);
 * nếu cần reset auth khi logout/session hết hạn thì commit riêng `${ModuleAuth}/resetState`.
 */
export const ResetModules = [
	ModuleCommon,
	ModuleCompany,
	ModuleConfig,
	ModuleContactAdditional,
	ModuleDashboard,
	ModuleDictionary,
	ModuleLayout,
	ModuleLicenseInfo,
	ModuleAccessLog,
	ModuleMisaOrder,
	ModuleNotification,
	ModuleOptions,
	ModuleServiceTVAN,
	ModuleTaxRegis,
	ModuleTaxReturnRegisHistory,
	ModuleTaxReturn,
	ModuleTaxReturnSubmission,
	ModuleTaxPaper,
	ModuleTaxPayerInfo,
	ModuleUser,
	ModuleStateBudget,
	ModuleProducts,
	ModuleNotiSetting,
	ModuleMisaStore,
	ModuleRemoteSigning,
	ModuleAgreement,
	ModuleAmisConvert
];
